import { api } from "../../../api";
import { toastMessageConfig } from "../../../../entities/toastMessageConfig";
import { getGroupedOptionsObj } from "./lib";

export const loadOptions = async (
  systemStringId,
  scopeStringId,
  filterObjState,
  optionsObjState,
  toastRef
) => {
  const [filterObjStateValue] = filterObjState;

  const getOptionsResponseObj = await api.fieldsForMapping[systemStringId].get(
    scopeStringId,
    filterObjStateValue
  );

  const { error, warning } = getOptionsResponseObj;

  if (warning) {
    toastRef.current.show({
      severity: "warn",
      summary: warning.title,
      detail: warning.message,
      life: toastMessageConfig.life,
    });
    return;
  }

  if (error) {
    toastRef.current.show({
      severity: "error",
      summary: error.title,
      detail: error.message,
      sticky: true,
    });
    return;
  }

  const [, setOptionsObjStateValue] = optionsObjState;

  setOptionsObjStateValue((prevValue) => ({
    ...(prevValue?.selectedOptionGroup
      ? { selectedOptionGroup: prevValue?.selectedOptionGroup }
      : {}),
    ...getGroupedOptionsObj(getOptionsResponseObj),
  }));
};
